<template>
    <div>
        <v-layout justify-center align-center>
            <v-flex>
                <v-card class="elevation-12 cardRanking" max-width="800px">
                    <v-layout justify-end column>
                        <v-flex>
                            <v-layout justify-end>
                                    <v-icon class="iconClear" v-on:click="closeRanking">clear</v-icon>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    <v-layout justify-center class="titlesCard">
                        <v-flex xs2></v-flex>
                        <v-flex xs7>
                            <br>
                            <div>{{$t('ranking_imgText')}}</div>
                        </v-flex>
                        <v-flex xs12>
                            <br>
                            <div>{{$t('ranking_usernameText')}}</div>
                        </v-flex>
                        <v-flex xs7>
                            <br>
                            <div>{{$t('ranking_scoreText')}}</div>
                        </v-flex>
                    </v-layout>
                    <div v-for="(user,index) in usersRanking"
                         :key="index"
                         v-if="index===rowTest[index]"
                         :class="{firstRanking: index===0}"
                         class="usersText"
                    >
                        <v-layout justify-center>
                            <v-flex xs3></v-flex>
                            <v-flex xs6>
                                <br>
                                <img :src="user.imgUser" class="imgRanking" :class="{imgRanking2: index===0}" alt="">
                            </v-flex>
                            <v-flex xs12>
                                <br>
                                <div>{{user.username}}</div>
                            </v-flex>
                            <v-flex xs6>
                                <br>
                                <div>{{user.score}}</div>
                            </v-flex>
                        </v-layout>
                    </div>
                    <br>
                </v-card>
            </v-flex>
        </v-layout>
        {{computedCompare}}

    </div>

</template>

<script>
    import {db} from '../firebaseConfig'

    let usersRef = db.ref('Users');

    export default {
        name: "Ranking",
        firebase: {
            usersRef
        },
        data() {
            return {
                rowTest: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
                headers: [
                    {text: '', value: "string", align: 'center'},
                    {text: 'Usuari', value: "string", align: 'right'},
                    {text: 'Total punts', value: 'number', align: 'right'}
                ],
                usersRanking: [],
                scoreUsersRanking: 0
            }
        },
        created() {
            this.compareScore();
        },
        methods: {
            compareScore() {

                this.usersRanking = [];
                for (let i = 0; i < this.usersRef.length; i++) {

                    this.usersRanking.push(this.usersRef[i])
                }

                this.usersRanking.sort(function (a, b) {
                    if (a.score > b.score) {
                        return -1;
                    }
                    if (a.score < b.score) {
                        return 1;
                    }
                    // a must be equal to b
                    return 0;
                });
            },
            closeRanking () {
                this.$store.commit('changeShowRankingFalse');
            }
        },
        computed: {
            computedCompare() {
                this.compareScore();
            }
        }
    }
</script>

<style lang="scss">

    @import url('https://fonts.googleapis.com/css?family=Josefin+Sans&display=swap');

    .iconClear{
        margin-top: 2%;
        margin-right: 2%;
    }

    .containerAll {
        height: 60px;
    }

    .cardRanking{
        border-radius: 20px;
    }

    .titlesCard {
        font-size: 18px;
        font-family: 'Josefin Sans', sans-serif;
    }

    .usersText {
        background: #F5F5F5;
        margin-top: 2%;
        border-radius: 20px;
    }

    .firstRanking {
        background:  #FCE15C;
        border-radius: 20px;
        font-weight: bold;
    }

    .containerRanking {
        width: 70%;
        height: 100%;
        justify-content: center;
    }

    .test {
        width: 100px;
    }

    .imgRanking {
        width: 30px;
        height: 30px;
        border-radius: 50%;
    }

</style>
